module.exports = __webpack_public_path__ + "static/media/inspired-pharma-training.a6a026b4.png";